module.exports = __webpack_public_path__ + "static/media/PoweredByShipVia.8c643b44.png";